<template>
	<div class="default-input" :class="{'default-input--error' : errors.length, 'default-input--bg' : inputGray, 'default-input--readonly' : readonly}">
		<label class="default-input__label" v-if="label" :for="id">{{ label }}</label>
		<div class="default-input__wrapper">
			<div class="default-input__input" :class="{'default-input__input--with-btn': actionBtn}">
				<input ref="inputText"
					:type="this.password ? 'password' : 'text'"
					v-model="value"
					:placeholder="placeholder"
					:id="id"
					:inputmode="inputType"
					:disabled="disabled"
					:readonly="readonly">
			</div>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li>{{ errors[0].$message }}</li>
		</ul>
	</div>
</template>

<script>
import Inputmask from 'inputmask'

export default {
	name: "InputText",
	emits:['update:modelValue', "text"],
	props: {
		modelValue: {
			type: [String, Number],
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		actionBtn: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Array,
			default: () => []
		},
		inputGray: {
			type: Boolean,
			default: false
		},
		cost: {
			type: Boolean,
			default: false
		},
		phone: {
			type: Boolean,
			default: false
		},
		number: {
			type: Number,
			default: null
		},
		password: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.cost) {
			Inputmask({
				'alias': 'decimal',
				'groupSeparator': ' ',
				'autoGroup': true,
				'digits': 2,
				'digitsOptional': true,
				'rightAlign': false,
				'placeholder': '',
				'showMaskOnHover': false,
			}).mask(this.$refs.inputText)
		}
		if(this.number) {
			let stringMask = ''
			for(var i = 0; i < this.number; i++){
				stringMask += '9'
			}
			Inputmask({
				'mask': stringMask,
				'autoGroup': true,
				'digits': 0,
				'digitsOptional': false,
				'rightAlign': false,
				'placeholder': '',
				'showMaskOnHover': false,
			}).mask(this.$refs.inputText)
		}
		if(this.phone) {
			Inputmask({
				mask: '+9{1,}|9',
				placeholder: ''
			}).mask(this.$refs.inputText)
		}
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		},
		inputType() {
			if(this.phone) {
				return 'numeric'
			}
			return 'text'
		}
	}
}
</script>


